module.exports = ".warn{background:#b73125;color:#fff}\n"